import {styles} from '../styles';

export function Part(props) {
    const {part} = props;

    return <div class={styles.classes.part}>{part}</div>;
}
